import React from 'react'
import "./Home.css"
import Product from './Product'

function Home() {
    return (
        <div className='home'>
            <div className="home__container">
            <img className='home__image'
                 src='https://m.media-amazon.com/images/G/01/digital/video/sonata/US_SVOD_NonPrime_Banner/f69c4124-8751-4646-b8de-14e68f14ff8e._UR3000,600_SX1500_FMwebp_.jpg' alt=''
                />
            <div className='home__row'>
               
            <Product
            id = '1233436'
            title="Crompton Senorita Opal" 
            price ={2595}
            rating={4}
            image ="https://cdn1.smartprix.com/rx-ii5B78ume-w240-h290/crompton-senorita-op.webp"
            
            />
            <Product
            id = '1233437'
            title="Apple MacBook Air" 
            price ={99595}
            rating={5}
            image ="https://cdn1.smartprix.com/rx-iv9zmdsLG-w240-h290/apple-macbook-air-mq.webp"
            
            />
                
            </div>
            <div className='home__row'>
               
            <Product 
                id = '123343'
                title="Iphone 7" 
                price ={ 12000}
                rating={4}
                image ="https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/iphone11-select-2019-family?wid=882&amp;hei=1058&amp;fmt=jpeg&amp;qlt=80&amp;op_usm=0.5,0.5&amp;.v=1567022175704"
                
                />
                <Product 
                id = '1233434'
                title="Iphone 11 pro" 
                price ={36000}
                rating={4}
                image ="https://cdn1.smartprix.com/rx-izngpupdU-w240-h290/apple-iphone-11-pro.webp"
                
                />
                <Product 
                id = '1233435'
                title="Iphone 12 max" 
                price ={ 100000}
                rating={5}
                image ="https://cdn1.smartprix.com/rx-i1Rx06ubR-w240-h290/apple-iphone-12-pro.webp"
                
                />
                
            </div>
            <div className='home__row'>
            <Product
                id = '1233438'
                title="eAirtec 81 cm" 
                price ={32000}
                rating={4}
                image ="https://cdn1.smartprix.com/rx-i5aBE1MKX-w240-h290/haier-le32k6000b-32.webp"
                
                />
            </div>




            </div>
        </div>
    )
}

export default Home
